"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MessageBox = void 0;
/*
  © 2024 Renishaw plc. All rights reserved.
  This source file is the confidential property and copyright of Renishaw plc.
  Reproduction or transmission in whole or in part, in any form or
  by any means, electronic, mechanical or otherwise, is prohibited
  without the prior written consent of the copyright owner.
*/
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importDefault(require("../styled-components"));
const __1 = require("..");
/** Full-screen backdrop that blocks interaction with the page while the popup is open */
const Overlay = styled_components_1.default.div `
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.45);
  z-index: 999;
`;
/** Centre this popup on the page, rather than attaching it to an element as usual */
const PopperWrapper = styled_components_1.default.div `
  position: fixed;
  top: 40%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 100%;
  max-width: 400px;
  z-index: 1000;
`;
/** Raised dark panel - custom styling intentionally differs from other popups */
const BodyWrapper = styled_components_1.default.div `
  margin: -17px -10px 3px;
  padding: ${({ theme }) => theme.gutter};
  background: ${({ theme }) => theme.panel};
  box-shadow: ${({ theme }) => theme.boxShadows.standard + "," + theme.boxShadows.highlight};
  border-radius: ${({ theme }) => theme.radius};
`;
/** custom styling intentionally differs from other popups */
const TitleWrapper = styled_components_1.default.div `
  padding: 0 10px;
  margin-top: 5px;
  font-size: 18px;
  align-items: center;
  height: 40px;
  display: flex;
  gap: 10px;
`;
/** Customised popup for showing an alert.
 * It displays in the centre of the page, the content is in a raised panel, it has different margins, and larger buttons and header text. */
const MessageBox = ({ open, header, body, footer, onClose, isCloseButtonDisabled = false, }) => {
    return open ? (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(Overlay, null),
        react_1.default.createElement(PopperWrapper, { onClick: (evt) => evt.stopPropagation() },
            react_1.default.createElement(__1.PopupLayout, { flat: true, isCloseButtonDisabled: isCloseButtonDisabled, title: react_1.default.createElement(TitleWrapper, null,
                    header.icon === "warning" ? (react_1.default.createElement(__1.WarningIcon, { size: 26 })) : header.icon === "info" ? (react_1.default.createElement(__1.Info, { size: 26 })) : header.icon === "error" ? (react_1.default.createElement(__1.AlertError, { size: 26 })) : (""),
                    header.heading), primaryActions: footer.buttons.map(({ label, onClick, disabled }) => (react_1.default.createElement(__1.Button, { style: { minWidth: 90 }, key: label, onClick: onClick, disabled: disabled }, label))), onClose: () => onClose() },
                react_1.default.createElement(BodyWrapper, null, body.message))))) : null;
};
exports.MessageBox = MessageBox;
//# sourceMappingURL=index.js.map